import React, { useState, useEffect } from 'react';
import { List, Picker } from 'antd-mobile';

import * as Api from "../../../api/usms";

import { AuditingStatus, TextCategory, SignatureType, UsmsStatus, UsmsStatusStyle } from '../utils/const';
import { Loading, Empty, TitleDescriptions } from '../components';

import '../index.css';

function Signatures(props) {

    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [selectStatus, setSelectStatus] = useState();

    useEffect(() => {
        getList()
    }, [])

    useEffect(() => {
        selectStatus && getList(selectStatus)
    }, [selectStatus])

    const getList = (status) => {
        const data = {
            SignatureCategory: TextCategory,
            Status: status || AuditingStatus,
            Limit: 1000,
            Offset: 0
        }
        setLoading(true);
        Api.DescribeUSMSSignature(data).then(res => {
            setList(res);
            setLoading(false);
        }).catch(e => {
            setLoading(false);
            setErrorMessage(e.message || "获取数据失败")
        });
    }

    const renderStatusSelector = () => {
        const statusOptions = Object.keys(UsmsStatus).map(item => ({
            label: UsmsStatus[item],
            value: item,
        }))

        return <Picker
            data={[statusOptions]}
            title="选择状态"
            cascade={false}
            value={selectStatus}
            onOk={v => setSelectStatus(v)}
        >
            <span className="a-blue">{selectStatus ? UsmsStatus[selectStatus[0]] : "待审核"}</span>
        </Picker>
    }
    return (
        <div className="container">
            <div style={{ float: 'right' }}>{renderStatusSelector()}</div>
            <h3 className='mb-10'>短信签名：</h3>
            <Loading loading={loading} error={errorMessage}>
                {list.length > 0 ?
                    <List>
                        {list.map((item, index) => <List.Item
                            arrow="horizontal"
                            onClick={() => window.location.href = `/usms/signaturedetail?id=${item.SignatureId}`}
                            key={index}
                        >
                            <TitleDescriptions
                                title={item.Signature}
                                descriptions={[
                                    item.SignatureId,
                                    // UsmsType[item.SignatureCategory],
                                    SignatureType[item.SignatureType],
                                    <span className={UsmsStatusStyle[item.Status]}>{UsmsStatus[item.Status]}</span>
                                ]}
                            />
                        </List.Item>)}
                    </List>
                    : <Empty />}
            </Loading>
        </div>
    )
}
export default Signatures